import React from 'react';
import { Link } from 'react-router-dom';
import '../../Zone/zone.css';

function ThreeDVideos() {
  const videoLinks = [
    "https://www.youtube.com/embed/2UOYfgaNUmo",
    "https://www.youtube.com/embed/MQEkFppWaRI",
    "https://www.youtube.com/embed/wbghM2fM_Gs",
    "https://www.youtube.com/embed/DtOwCCA4-SU",
    "https://www.youtube.com/embed/18umQIjcLgQ",
    "https://www.youtube.com/embed/B9M-5-ahHsQ",
    "https://www.youtube.com/embed/4GOFa5C0Zzk"
  ];

  return (
    <div style={{
      backgroundColor: 'black',
      minHeight: '100vh',
      padding: '20px 15px',
      color: 'white',
      fontFamily: 'Arial, sans-serif'
    }}>
      <h1 style={{
        textAlign: 'center',
        marginBottom: '40px',
        fontSize: '26px',
        textShadow: '0 0 8px #fff'
      }}>
        🎥 3D Videos Showcase
      </h1>

      <div style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '20px',
        justifyContent: 'center',
        maxWidth: '1200px',
        margin: 'auto',
        marginBottom: '50px'
      }}>
        {videoLinks.map((link, index) => (
          <div key={index} style={{
            borderRadius: '8px',
            overflow: 'hidden',
            boxShadow: '0 0 12px #222',
            flex: '0 0 calc(33.33% - 20px)', // 3 columns with gap
            maxWidth: 'calc(33.33% - 20px)'
          }}>
            <iframe
              width="100%"
              height="200"
              src={link}
              title={`3D Video ${index + 1}`}
              frameBorder="0"
              style={{ display: 'block' }}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        ))}
      </div>

      <div style={{ textAlign: 'center' }}>
        <Link
          to="/zones"
          style={{
            backgroundColor: '#444',
            color: '#fff',
            padding: '10px 22px',
            borderRadius: '25px',
            textDecoration: 'none',
            fontSize: '14px',
            boxShadow: '0 0 5px #fff',
            transition: 'background 0.3s'
          }}
          onMouseOver={(e) => e.target.style.backgroundColor = '#666'}
          onMouseOut={(e) => e.target.style.backgroundColor = '#444'}
        >
          ⬅ Back to Museum Realms
        </Link>
      </div>
    </div>
  );
}

export default ThreeDVideos;
